import { AnyAction } from 'redux';
import { ActionTypes } from '../constants/index';
import { SubscribedUserManagement } from '../modal';


export default function reducer(state: SubscribedUserManagement = new SubscribedUserManagement(), action: AnyAction) {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.SUBSCRIBED_USER_MGMT_REQUEST:
      return {
        ...state,
        loadingInProgress: true,
      };
    case ActionTypes.SUBSCRIBED_USER_MGMT_SUCCESS:
      return {
        ...state,
        loadingInProgress: false,
        data: payload,
      };
    case ActionTypes.SUBSCRIBED_USER_MGMT_ERROR:
      return {
        ...state,
        loadingInProgress: false,
        loadingError: payload,
      };
    default:
      return state;
  }
}
